(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["seo-copy-and-faqs"] && !Shopify.designMode) return;
  try {
    
// FAQs Accordion (keep this at root level)
var acc = document.getElementsByClassName("faqs-accordion");
for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnl-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-tst-section]');
  if (!sections.length) return;

  sections.forEach((sectionRoot) => {
    const carousel = sectionRoot.querySelector('[data-tst-carousel]');
    if (!carousel) return;

    if (carousel.dataset.tstInit === 'true') return;
    carousel.dataset.tstInit = 'true';

    const slides = Array.from(carousel.querySelectorAll('[data-tst-slide]'));
    const prevBtn = carousel.querySelector('[data-tst-prev]');
    const nextBtn = carousel.querySelector('[data-tst-next]');
    const dotsWrap = carousel.querySelector('[data-tst-dots]');
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('[data-tst-dot]')) : [];

    if (slides.length === 0) return;

    let index = 0;

    function clamp(i) {
      return Math.max(0, Math.min(slides.length - 1, i));
    }

    function setActiveDot(i) {
      dots.forEach((d) => d.setAttribute('aria-current', 'false'));
      if (dots[i]) dots[i].setAttribute('aria-current', 'true');
    }

    function updateButtons(i) {
      if (prevBtn) prevBtn.disabled = (slides.length <= 1 || i <= 0);
      if (nextBtn) nextBtn.disabled = (slides.length <= 1 || i >= slides.length - 1);
    }

    function setActiveSlide(i) {
      slides.forEach((s) => s.classList.remove('is-active'));
      if (slides[i]) slides[i].classList.add('is-active');
    }

    function goTo(i) {
      index = clamp(i);
      setActiveSlide(index);
      setActiveDot(index);
      updateButtons(index);
    }

    prevBtn && prevBtn.addEventListener('click', () => goTo(index - 1));
    nextBtn && nextBtn.addEventListener('click', () => goTo(index + 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const i = parseInt(dot.getAttribute('data-tst-dot'), 10);
        if (!Number.isNaN(i)) goTo(i);
      });
    });

    goTo(0);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
